module.exports = __webpack_public_path__ + "img/048-abkhazia.c81172af.svg";